import React from 'react';

export const MyAccountLazy = React.lazy(() => import('./MyAccount'));
